import React, {useMemo} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import GridBlock from "components/GridBlock";
import Form from "components/Form";
import useId from "hooks/useId";
import VS from "constants/ValidationShema";
import {connect} from "react-redux";
import * as Yup from "yup";
import {SignatureType, SignatureTypeLabel} from "../../../constants/SignatureType";
import RadioGroup from "../../RadioGroup";
import {createSelectItem} from "../../Select";

const ChooseSignatureTypePopup = (
    {
        signatureTypes,
        onCancel,
        onSuccess,
        formSubmit
    }) => {

    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();
    const types = useMemo(
        () => signatureTypes.map(x => createSelectItem(x, SignatureTypeLabel(x)))
        , [signatureTypes])

    const onSubmit = ({signature}) => {
        onSuccess(signature)
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel, 'outlined'));
        buttons.push(createButton(Tr('select'), handleSubmit, undefined));
        return buttons;
    }

    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            maxWidth='md'
            title={Tr('signature_select_type_label')}
        >
            <GridBlock
                column
            >

                <Form
                    initialValues={{
                        signature: null
                    }}
                    validationSchema={Yup.object().shape({
                        signature: VS.string()
                    })}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <GridBlock
                            column
                        >
                            <RadioGroup
                                id='signature'
                                label=""
                                formikProps={formikProps}
                                items={types}
                            />
                        </GridBlock>
                    )}
                </Form>

            </GridBlock>
        </Dialog>)
}

ChooseSignatureTypePopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    signatureTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(SignatureType)))
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(ChooseSignatureTypePopup)